module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cha"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("“The Lumière Cinematograph,” "), _c('i', [_vm._v("El Monitor Republicano")]), _vm._v(" (Mexico City), August 16, 1896")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "chq"
  }, [_c('i', [_vm._v("This unsigned account of one of the earliest exhibitions of moving images in Mexico City emphasizes not only the curiosity produced by the apparatus and its naturalistic reproduction of motion but also its proximity to other popular amusements, including the magic lantern and the circus, in a modernizing capital city")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE NIGHT BEFORE LAST")]), _vm._v(", on the top floor of the Plateros Drugstore (the second block of Plateros Street, number 9), an exhibition of the apparatus called the “Lumière Cinématograph” dedicated to the press of this capital took place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cinematograph is a type of magic lantern that projects a luminous cone onto a white screen placed in front of the spectators.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the luminous field of the screen, scenes full of life and movement unfold, caught unawares by inventor’s photographic apparatus.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("The night before last we viewed the following scenes: "), _c('i', [_vm._v("The Arrival of a Train, Rollercoasters, A Cavalry Charge, Card Party, The Baby’s Meal, Workers Leaving the Factory, The Sprinkler Sprinkled, Demolition of a Wall")]), _vm._v(", and "), _c('i', [_vm._v("Swimming in the Sea")]), _vm._v("."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfna_1",
      "id": "fna_1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each scene is more marvelous than the last.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the arrival of the train, one sees the locomotive advance with all its natural movements, followed by the cars carrying the passengers, who disembark hurriedly and move away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The scene is so natural that one almost seems to hear the noise of the train and the bustling of the passengers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the rollercoasters, a scene is shown similar to the one we saw in the pantomime "), _c('i', [_vm._v("A Baptism during Carnival")]), _vm._v(" at the Orrín Circus: a small boat that slides down a ramp and breaks the surface of the water, scattering it into a fine spray that envelops the vessel for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("In the cavalry charge, one clearly sees the immense cloud of dust kicked up by the hooves of the horses, which envelops the field of operations in a dense haze.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In the card players, one can see the sometimes pensive, sometimes fevered attitude of the players, while the waiter approaches with a tray and bottles of beer and peeks behind the head of one of the players to see the cards in his hand, while a third player pours the beer from the bottles into the glasses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The baby’s meal is a scene in the home of M. Auguste Lumière, inventor of the apparatus. One can see, seated at the table, M. Lumière on one side; his son, a young child, in the middle; and on the other side, Lumière’s wife M. Lumière gives sweets to the boy, while his wife serves coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The exit from the Lumière factory shows the moment in which a large number of female workers leave the factory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The gardener and the boy is a comic scene. The gardener waters the garden with a rubber hose; the boy steps on the hose and prevents the water from flowing. When the gardener inspects the mouth of the hose, the boy lifts his foot and the water shoots out, soaking the gardener’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the demolition of a wall, M. Lumière again appears, directing the operation: the wall falls and a cloud of dust envelops the workers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the bathers, they are seen on a beach diving into the sea; one observes the movement of the waves and the splashing of the water as the bathers tumble.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("In all of these scenes, the movements are perfectly photographed: there is natural life and animation in them, and all of this produces the most marvelous effect.")]), _vm._v(" "), _c('p', {
    staticClass: "rightb"
  }, [_c('i', [_vm._v("Translated by Diana Norton and Rielle Navitski")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IELLE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVITSKI")]), _vm._v(" is Assistant Professor of Theater and Film Studies at the University of Georgia. She is the author of "), _c('i', [_vm._v("Public Spectacles of Violence: Sensational Cinema and Journalism in Early Twentieth-Century Mexico and Brazil")]), _vm._v(" (Duke University Press, 2017).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IANA")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORTON")]), _vm._v(" is a PhD candidate at the University of Texas in Austin, currently writing her dissertation on "), _c('i', [_vm._v("Hispanidad")]), _vm._v(" and the star discourses of Hollywood and Latin American actresses in Spain.")])])]), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fna_1",
      "id": "rfna_1"
    }
  }, [_vm._v("1")]), _vm._v(". "), _c('i', [_vm._v("Editors’ Note:")]), _vm._v(" For clarity, we have used common English-language versions of the film titles. The titles used by the journalist differ slightly; we have preserved them in the wording of following paragraphs, in which the author briefly describes each of the films without referring to them by title.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d2bc87e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12_Chaptera.vue
// module id = 93
// module chunks = 0